import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-already-submitted',
  templateUrl: './already-submitted.component.html',
  styleUrls: ['./already-submitted.component.scss']
})
export class AlreadySubmittedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
